<template>
  <div>
    <section class="member-box">
      <div class="container">
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";
import VueMeta from "vue-meta";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(VueMeta);

const messages = {
  zh_tw: {
    "下載APP": "下載APP",
    "請選擇您的裝置下載APP": "請選擇您的裝置下載APP",
    "從App Store下載": "從App Store下載",
    "從Google Play下載": "從Google Play下載",
  },
  en: {
    "下載APP": "Download APP",
    "請選擇您的裝置下載APP": "Please select your device to download the APP",
    "從App Store下載": "Download from App Store",
    "從Google Play下載": "Download from Google Play",
  },
  jp: {
    "下載APP": "APPダウンロード",
    "請選擇您的裝置下載APP": "デバイスを選択してAPPをダウンロードしてください",
    "從App Store下載": "App Storeからダウンロード",
    "從Google Play下載": "Google Playからダウンロード",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "DownloadApp",
  i18n,
  data() {
    return {
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isAndroid: /Android/.test(navigator.userAgent),
    };
  },
  created: function () {
    this.$swal({
      heightAuto: false,
      title: this.$t("請稍候..."),
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
    // 如果是手機開啟，自動跳轉到相應的商店
    if (this.isMobile) {
      if (this.isIOS) {
        window.location.href =
          "https://apps.apple.com/tw/app/men-go-交通行動服務/id1415685647";
      } else if (this.isAndroid) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.heimavista.omaas";
      }
      setTimeout(() => {
        this.$swal.close();
        this.$router.push({ name: "Home" });
      }, 500);
    } else {
      // 非手機則延遲後返回首頁
      setTimeout(() => {
        this.$swal.close();
        this.$router.push({ name: "Home" });
      }, 500);
    }
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").removeClass("travel");
    $(".wrapper").removeClass("travel-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    downloadApple() {
      const appleUrl = "itms-apps://itunes.apple.com/app/id1415685647";
      const appleWebUrl =
        "https://apps.apple.com/tw/app/men-go-交通行動服務/id1415685647";

      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(appleUrl, "_system");
      } else {
        window.open(appleWebUrl, "_blank");
      }
    },
    downloadAndroid() {
      const androidUrl = "market://details?id=com.heimavista.omaas";
      const androidWebUrl =
        "https://play.google.com/store/apps/details?id=com.heimavista.omaas";

      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(androidUrl, "_system");
      } else {
        window.open(androidWebUrl, "_blank");
      }
    },
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download-app-content {
  text-align: center;
  margin: 30px 0;
  font-size: 16px;
  color: #333;
}

.btn-box {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;
}

.form-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.form-btn img {
  width: 24px;
  height: 24px;
}

.form-btn.apple {
  background-color: #000;
  color: #fff;
}

.form-btn.apple:hover {
  background-color: #333;
}

.form-btn.android {
  background-color: #3ddc84;
  color: #fff;
}

.form-btn.android:hover {
  background-color: #2eb96e;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadApp.vue